import {
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    styled,
} from "@mui/material"
import React from "react"

const StyledListItemButton = styled(ListItemButton, {
    shouldForwardProp: (prop) => prop !== "isActive",
})(({theme, isActive}) => theme.NAVBAR.navBarListItem(theme, isActive))

const NavBarListItem = ({
    open,
    label,
    icon,
    onClick,
    isActive,
}) => {
    return (
        <ListItem key={label}>
            <StyledListItemButton
                isActive={isActive}
                onClick={onClick}
                sx={{
                    px: open ? 2.5 : 0.5,
                }}>
                <ListItemIcon
                    sx={{
                        minWidth: 0,
                        mr: open ? 3 : 0,
                    }}>
                    {icon}
                </ListItemIcon>
                <ListItemText
                    primary={label}
                    sx={{display: open ? "block" : "none"}}
                />
            </StyledListItemButton>
        </ListItem>
    )
}

export default NavBarListItem
